import { getCultureByLocale } from "CMS/utils";
import { DefaultActivityContent } from "components/ActivityPanel/ActivityCard";
import CultureLabel from "components/Culture/CultureLabel";
import React from "react";

interface CardProps {
  activity: server.dto.ExcelTemplateActivity
}

const ExcelTemplateActivityCardContent = (props: CardProps) => {
  const { action } = props.activity;

  if (action.value === "modifyDistinctRows") {
    return props.activity.content === "True" ? <>{RESX.GeneralLabels.Yes}</> : <>{RESX.GeneralLabels.No}</>;
  }

  if (action.value === "modifyCulture") {
    const culture = getCultureByLocale(props.activity.content as server.dto.LCID);
    if (culture) {
      return <CultureLabel culture={culture} />
    }

    return null;
  }

  return <DefaultActivityContent activity={props.activity} />
}

export default ExcelTemplateActivityCardContent;